/* eslint-disable */
import GraphQL from '../../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageFieldStatisticsChartQueryVariables = GraphQL.Exact<{
  fields: ReadonlyArray<GraphQL.Scalars['String']['input']> | GraphQL.Scalars['String']['input'];
  filter: GraphQL.InputMaybe<GraphQL.Scalars['Array']['input']>;
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageFieldStatisticsChartQuery = { readonly __typename?: 'Query', readonly pagesStatistics: { readonly __typename?: 'PagesStatistics', readonly total: number, readonly statistics: ReadonlyArray<{ readonly __typename?: 'PagesStatisticsPerScope', readonly field: string, readonly scopes: ReadonlyArray<Record<string, any>> } | null> } | null };


export const PageFieldStatisticsChartDocument = gql`
    query PageFieldStatisticsChart($fields: [String!]!, $filter: Array, $websiteId: WebsiteId!) {
  pagesStatistics(fields: $fields, filter: $filter, websiteId: $websiteId) {
    statistics {
      field
      scopes
    }
    total
  }
}
    `;

/**
 * __usePageFieldStatisticsChartQuery__
 *
 * To run a query within a React component, call `usePageFieldStatisticsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageFieldStatisticsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageFieldStatisticsChartQuery({
 *   variables: {
 *      fields: // value for 'fields'
 *      filter: // value for 'filter'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageFieldStatisticsChartQuery(baseOptions: Apollo.QueryHookOptions<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables> & ({ variables: PageFieldStatisticsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>(PageFieldStatisticsChartDocument, options);
      }
export function usePageFieldStatisticsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>(PageFieldStatisticsChartDocument, options);
        }
export function usePageFieldStatisticsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>(PageFieldStatisticsChartDocument, options);
        }
export type PageFieldStatisticsChartQueryHookResult = ReturnType<typeof usePageFieldStatisticsChartQuery>;
export type PageFieldStatisticsChartLazyQueryHookResult = ReturnType<typeof usePageFieldStatisticsChartLazyQuery>;
export type PageFieldStatisticsChartSuspenseQueryHookResult = ReturnType<typeof usePageFieldStatisticsChartSuspenseQuery>;
export type PageFieldStatisticsChartQueryResult = Apollo.QueryResult<PageFieldStatisticsChartQuery, PageFieldStatisticsChartQueryVariables>;